import { Helmet } from "react-helmet-async";
import { useSiteSetting } from "@/hooks/useCms";

type Seo = { title?: string; description?: string; og_image?: string };

/**
 * Applies admin-configured SEO defaults globally. Per-page Helmet overrides still win
 * because react-helmet-async merges by tag, and tags rendered closer to the page take precedence.
 */
const GlobalSeoDefaults = () => {
  const { data } = useSiteSetting<Seo>("seo_defaults");
  if (!data) return null;
  return (
    <Helmet>
      {data.title && <meta name="application-name" content={data.title} />}
      {data.description && <meta name="description" content={data.description} />}
      {data.og_image && <meta property="og:image" content={data.og_image} />}
      {data.og_image && <meta name="twitter:image" content={data.og_image} />}
    </Helmet>
  );
};

export default GlobalSeoDefaults;
